import React from "react";

import { Input } from "~/components/input";

import type { DashboardTextVariable } from "../../../../common/dashboard-spec";

import { VARIABLE_VALUE_FALLBACK_STRING } from "./_common";

interface Props extends DashboardTextVariable {
	onChange: (newValue: string) => void;
}

export const TextVariable = ({ constant, onChange, value }: Props): React.JSX.Element => (
	<Input
		onChange={(event) => {
			onChange(event.target.value);
		}}
		placeholder={VARIABLE_VALUE_FALLBACK_STRING}
		readOnly={constant}
		value={value}
	/>
);
